import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as api from "./analyticsApi";

export const fetchOverview = createAsyncThunk("analytics/fetchOverview", async (_, { getState, rejectWithValue }) => {
  try {
    const token = getState().user.user.token;
    const res = await api.getOverview(token);
    return res.data;
  } catch (err) {
    return rejectWithValue(err?.response?.data?.message || err?.message || "Failed to fetch analytics");
  }
});

export const fetchPostAnalytics = createAsyncThunk("analytics/fetchPostAnalytics", async (postId, { getState, rejectWithValue }) => {
  try {
    const token = getState().user.user.token;
    const res = await api.getPostAnalytics(postId, token);
    return res.data;
  } catch (err) {
    return rejectWithValue(err?.response?.data?.message || err?.message || "Failed to fetch post analytics");
  }
});

const analyticsSlice = createSlice({
  name: "analytics",
  initialState: { overview: null, postAnalytics: null, loading: false, error: null },
  reducers: {
    clearPostAnalytics: (state) => { state.postAnalytics = null; },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOverview.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchOverview.fulfilled, (state, action) => {
        state.loading = false;
        state.overview = action.payload;
      })
      .addCase(fetchOverview.rejected, (state, action) => { state.loading = false; state.error = action.payload; })

      .addCase(fetchPostAnalytics.pending, (state) => { state.loading = true; state.error = null; })
      .addCase(fetchPostAnalytics.fulfilled, (state, action) => {
        state.loading = false;
        state.postAnalytics = action.payload;
      })
      .addCase(fetchPostAnalytics.rejected, (state, action) => { state.loading = false; state.error = action.payload; });
  },
});

export const { clearPostAnalytics } = analyticsSlice.actions;
export default analyticsSlice.reducer;
